import { render, staticRenderFns } from "./ImageTemplate.vue?vue&type=template&id=b842ea34&"
import script from "./ImageTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports